const units = {}

/////////////
// RANGER //
///////////

units["dagger"] = {
    "jobKey": "dagger",
    "jobName": "Dagger",
    "skills": ["inflict-damage"],
    "element": "fire",
    "attacktype": "steel",
    "attackrange": 2,
    "moverange": 2,
    "maxhealth": 10,
    "power": 10,
    "defense": 3,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "daggers"
}

units["bow"] = {
    "jobKey": "bow",
    "jobName": "Bow",
    "skills": ["inflict-damage"],
    "element": "water",
    "attacktype": "steel",
    "attackrange": 2,
    "moverange": 2,
    "maxhealth": 10,
    "power": 10,
    "defense": 3,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "bow"
}

units["gun"] = {
    "jobKey": "gun",
    "jobName": "Gun",
    "skills": ["inflict-damage"],
    "element": "earth",
    "attacktype": "steel",
    "attackrange": 2,
    "moverange": 2,
    "maxhealth": 10,
    "power": 10,
    "defense": 3,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "gun"
}

/////////////////////
// RANGER MOUNTED //
///////////////////

units["bowcavalier"] = {
    "jobKey": "bowcavalier",
    "jobName": "Bowcavalier",
    "skills": ["inflict-damage"],
    "element": "water",
    "attacktype": "steel",
    "attackrange": 2,
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 10,
    "power": 10,
    "defense": 3,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
}

// TODO: daggerhorse?
// TODO: gunhorse?

//////////////
// FIGHTER //
////////////

units["sword"] = {
    "jobKey": "sword",
    "jobName": "Sword",
    "skills": ["inflict-damage"],
    "element": "fire",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 2,
    "maxhealth": 10,
    "power": 10,
    "defense": 3,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "sword"
}

units["spear"] = {
    "jobKey": "spear",
    "jobName": "Spear",
    "skills": ["inflict-damage"],
    "element": "water",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 2,
    "maxhealth": 10,
    "power": 10,
    "defense": 3,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "spear"
}

units["hammer"] = {
    "jobKey": "hammer",
    "jobName": "Axe", // ??
    "skills": ["inflict-damage"],
    "element": "earth",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 2,
    "maxhealth": 10,
    "power": 10,
    "defense": 3,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "hammer"
}

//////////////////////
// FIGHTER MOUNTED //
////////////////////

units["swordcavalier"] = {
    "jobKey": "swordcavalier",
    "jobName": "Swordcavalier",
    "skills": ["inflict-damage"],
    "element": "fire",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 10,
    "power": 10,
    "defense": 3,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "decalImageKey": "red-helmet",
    "weaponImageKey": "sword"
}

units["spearcavalier"] = {
    "jobKey": "spearcavalier",
    "jobName": "Spearcavalier",
    "skills": ["inflict-damage"],
    "element": "water",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 10,
    "power": 10,
    "defense": 3,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "decalImageKey": "blue-helmet",
    "weaponImageKey": "spear"
}

units["hammercavalier"] = {
    "jobKey": "hammercavalier",
    "jobName": "Axecavalier", // ??
    "skills": ["inflict-damage"],
    "element": "earth",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 10,
    "power": 10,
    "defense": 3,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "decalImageKey": "green-helmet",
    "weaponImageKey": "hammer"
}

//////////////////////
// FIGHTER ARMORED //
////////////////////

units["swordknight"] = {
    "jobKey": "swordknight",
    "jobName": "Swordknight",
    "skills": ["inflict-damage"],
    "element": "fire",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxarmor": 10,
    "armortype": "steel",
    "maxhealth": 10,
    "power": 10,
    "defense": 5,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "decalImageKey": "red-shield",
    "weaponImageKey": "sword"

    // // specific to chapterB
    // "skills": ["inflict-damage", "swords-up", "shields-up"],
    // "moverange": 2,
    // "defense": 10,
    // "resistance": 5,
    // "power": 6,
}

units["spearknight"] = {
    "jobKey": "spearknight",
    "jobName": "Spearknight",
    "skills": ["inflict-damage"],
    "element": "water",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxarmor": 10,
    "armortype": "steel",
    "maxhealth": 10,
    "power": 10,
    "defense": 5,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "decalImageKey": "blue-shield",
    "weaponImageKey": "spear"

    // // specific to chapterB
    // "skills": ["inflict-damage", "swords-up", "shields-up"],
    // "moverange": 2,
    // "defense": 10,
    // "resistance": 5,
    // "power": 8,
}

units["hammerknight"] = {
    "jobKey": "hammerknight",
    "jobName": "Axeknight", // ??
    "skills": ["inflict-damage"],
    "element": "earth",
    "attacktype": "steel",
    "attackrange": 1,
    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxarmor": 10,
    "armortype": "steel",
    "maxhealth": 10,
    "power": 10,
    "defense": 5,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "decalImageKey": "green-shield",
    "weaponImageKey": "hammer"

    // // specific to chapterB
    // "skills": ["inflict-damage", "swords-up", "shields-up"],
    // "moverange": 2,
    // "defense": 10,
    // "resistance": 5,
    // "power": 8,
}

////////////////////
// FIGHTER FLIER //
//////////////////

// units["swordflier"] = {
//     "jobKey": "swordflier",
//     "jobName": "Swordflier",
//     "fequivalent": "Wyvern Rider",
//     "skills": ["inflict-damage"],
//     "element": "fire",
//     "attacktype": "steel",
//     "attackrange": 1,
//     "moverange": 2,
//     "movetype": "flying",
//     "moveaudio": "Unit:Move:Wyvern",
//     "maxhealth": 10,
//     "power": 10,
//     "defense": 3,
//     "resistance": 0,
//     // "attackspeed": 5,
//     // "luck": 0,
//     "sprites": require("@frog/source/assets/images/fegba/units/red/swordcavalier").default
// }
//
// units["spearflier"] = {
//     "jobKey": "spearflier",
//     "jobName": "Spearflier",
//     "fequivalent": "Pegasus Rider",
//     "skills": ["inflict-damage"],
//     "element": "water",
//     "attacktype": "steel",
//     "attackrange": 1,
//     "moverange": 2,
//     "movetype": "flying",
//     "moveaudio": "Unit:Move:Wyvern",
//     "maxhealth": 10,
//     "power": 10,
//     "defense": 3,
//     "resistance": 0,
//     // "attackspeed": 5,
//     // "luck": 0,
//     "sprites": require("@frog/source/assets/images/fegba/units/red/spearcavalier").default
// }
//
// units["hammerflier"] = {
//     "jobKey": "hammerflier",
//     "jobName": "Hammerflier",
//     "fequivalent": "Falcon Flier",
//     "skills": ["inflict-damage"],
//     "element": "earth",
//     "attacktype": "steel",
//     "attackrange": 1,
//     "moverange": 2,
//     "movetype": "flying",
//     "moveaudio": "Unit:Move:Wyvern",
//     "maxhealth": 10,
//     "power": 10,
//     "defense": 3,
//     "resistance": 0,
//     // "attackspeed": 5,
//     // "luck": 0,
//     "sprites": require("@frog/source/assets/images/fegba/units/red/axecavalier").default
// }

///////////
// MAGE //
/////////

units["mage"] = {
    "jobKey": "mage",
    "jobName": "Mage",
    "fequivalent": "Mage",
    "skills": ["inflict-damage"],
    "element": "fire",
    "attacktype": "magic",
    "attackrange": 2,
    "moverange": 2,
    "maxhealth": 10,
    "power": 10,
    "defense": 0,
    "resistance": 5,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "red-staff",
}

units["priest"] = {
    "jobKey": "priest",
    "jobName": "Priest",
    "fequivalent": "Priest",
    "skills": ["inflict-damage"],
    "element": "water",
    "attacktype": "magic",
    "attackrange": 2,
    "moverange": 2,
    "maxhealth": 10,
    "power": 10,
    "defense": 0,
    "resistance": 5,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "blue-staff",
}

units["shaman"] = {
    "jobKey": "shaman",
    "jobName": "Shaman",
    "fequivalent": "Shaman",
    "skills": ["inflict-damage"],
    "element": "earth",
    "attacktype": "magic",
    "attackrange": 2,
    "moverange": 2,
    "maxhealth": 10,
    "power": 10,
    "defense": 0,
    "resistance": 5,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "green-staff",
}

///////////////////
// MAGE MOUNTED //
/////////////////

units["arcanecavalier"] = {
    "jobKey": "arcanecavalier",
    "jobName": "Arcane Cavalier",
    "fequivalent": "Mage Knight",
    "skills": ["inflict-damage"],
    "element": "fire",
    "attacktype": "magic",
    "attackrange": 2,
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 10,
    "power": 10,
    "defense": 0,
    "resistance": 5,
    // "attackspeed": 5,
    // "luck": 0,
    "decalImageKey": "red-helmet",
    "weaponImageKey": "red-staff",
}

units["divinecavalier"] = {
    "jobKey": "divinecavalier",
    "jobName": "Divine Cavalier",
    "fequivalent": "Valykrie",
    "skills": ["inflict-damage"],
    "element": "water",
    "attacktype": "magic",
    "attackrange": 2,
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 10,
    "power": 10,
    "defense": 0,
    "resistance": 5,
    // "attackspeed": 5,
    // "luck": 0,
    "decalImageKey": "blue-helmet",
    "weaponImageKey": "blue-staff",
}

units["eldritchcavalier"] = {
    "jobKey": "eldritchcavalier",
    "jobName": "Eldritch Cavalier",
    "fequivalent": "???",
    "skills": ["inflict-damage"],
    "element": "earth",
    "attacktype": "magic",
    "attackrange": 2,
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 10,
    "power": 10,
    "defense": 0,
    "resistance": 5,
    // "attackspeed": 5,
    // "luck": 0,
    "decalImageKey": "green-helmet",
    "weaponImageKey": "green-staff",
}



export default units
